import APP_CONFIG from 'constants/clientConfigs'
import {CLIENT_DISCOUNT_CODES, CLIENT_CODES_CO_UK} from 'constants/siteIds'

const Logo = () => {
  const client = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]

  if (client.clientId === CLIENT_DISCOUNT_CODES) {
    return (
      <div className="h-22 w-22 md:h-34 md:w-34 relative">
        <img
          className="object-contain"
          src="/discount-codes-logo.png"
          alt="discount-codes"
          width={120}
        />
      </div>
    )
  }

  if (client.clientId === CLIENT_CODES_CO_UK) {
    return (
      <div className="h-22 w-22 md:h-34 md:w-34 relative">
        <img
          className="object-contain"
          src="/codescouk-logo.png"
          alt="codescouk"
          width={164}
        />
      </div>
    )
  }

  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 180 34"
      enableBackground="new 0 0 180 34">
      <path
        fill="#F8DB00"
        d="M177.9,17.1c0,6.9-6.1,13.2-13,13.2c-2.9,0-6.8-1-9.2-2.6c-0.7-0.4-1.4-0.7-2-1.2c-0.2-0.2-0.5-0.3-0.9-0.3
c-0.8,0-1.4,0.6-1.4,1.4c0,0.3,0.1,0.6,0.3,0.9c3,3.1,7.2,4.9,11.8,4.9c9.1,0,16.5-7.3,16.5-16.4h-2.1V17.1z"
      />
      <path
        fill="#42B538"
        d="M151.5,6.3c0,0.8,0.6,1.4,1.4,1.4c0.3,0,0.5-0.1,0.7-0.2c0.6-0.4,1.3-0.8,2-1.2c2.5-1.5,6.3-2.7,9.2-2.7
c6.9,0,12.6,6.6,12.6,13.5h2.6c0-9.1-7.4-16.6-16.5-16.6c-4.6,0-8.7,1.9-11.7,4.9C151.6,5.7,151.5,6,151.5,6.3z"
      />
      <path
        fill="#00A1C0"
        d="M154.9,6.6c2.5-1.4,5.4-2.2,8.6-2.2c6.9,0,12.6,5.7,12.6,12.7c0,6.9-5.6,12.5-12.6,12.5
c-3.3,0-6.3-0.8-8.8-2.3c3,2.2,7,3.6,11.4,3.6c7.7,0,13.9-6.1,13.9-13.8s-6.2-14-13.9-14C161.8,3.1,157.9,4.5,154.9,6.6z"
      />
      <path
        fill="#383838"
        d="M161,13.3c0-0.8,0.9-1.3,2.6-1.3c0.9,0,1.9,0.1,2.6,0.4c0.5,0.2,1.1,0.4,1.5,0.5c1.3,0.2,2.2-1.3,1.6-2.4
c-0.2-0.4-0.3-0.5-0.7-0.7c-0.9-0.6-2.2-1.1-3.6-1.3c-0.1-0.7-0.8-1.3-1.6-1.3s-1.4,0.5-1.6,1.2c-3.2,0.4-5.2,2.6-5.2,4.9
c0,6.5,9.4,4.6,9.4,7.1c0,1-0.8,1.5-2.8,1.5c-1.6,0-2.7-0.5-4.1-1.1c-0.3-0.1-0.8-0.3-1.1-0.3c-0.9,0-1.5,0.8-1.5,1.8
c0,0.3,0.1,0.6,0.3,0.9c0.8,1.1,2.9,1.9,5,2.2c0.1,0.7,0.8,1.2,1.6,1.2s1.5-0.5,1.6-1.3c3.4-0.5,5.3-2.4,5.3-5.1
C170.4,14.3,161,16,161,13.3z"
      />
      <path
        fill="#383838"
        d="M143.9,15.2c0.3-1.3,1.5-3.1,4-3.1c2.4,0,3.7,2.1,3.8,3.1C151.7,15.2,143.9,15.2,143.9,15.2z M155.8,16.5
c0-0.8-0.2-1.8-0.5-2.6c-1.1-3.4-3.9-5.5-7.6-5.5c-5,0-8.4,3.8-8.4,8.5c0,5.2,3.7,8.6,8.7,8.6c2.2,0,6.3-0.9,6.3-2.8
c0-1-0.9-1.8-1.8-1.8c-0.3,0-0.6,0.1-0.8,0.2c-1,0.5-2.2,0.8-3.1,0.8c-2.8,0-4.3-1.5-4.6-3.5h9.9C154.9,18.5,155.8,17.6,155.8,16.5z
"
      />
      <path
        fill="#383838"
        d="M125.6,16.9c0-2.5,1.2-4.7,3.9-4.7c2.7,0,3.8,2.2,3.8,4.7c0,2.6-1.2,4.8-3.8,4.8S125.6,19.5,125.6,16.9z
 M133.3,4.7v5.5c-1.3-1-3.1-1.7-5-1.7c-4.1,0-7.1,3.3-7.1,8.6c0,5.4,3.1,8.6,7.1,8.6c2.4,0,4.2-1.5,4.9-2.1c0.1,1,1,2,2.1,2
c1.2,0,2.2-0.9,2.2-2.1V4.7c0-1.2-0.9-2.2-2.1-2.2C134.2,2.5,133.3,3.5,133.3,4.7z"
      />
      <path
        fill="#383838"
        d="M106.9,17c0-2.5,1.5-4.7,4.2-4.7s4.2,2.2,4.2,4.7c0,2.6-1.5,4.8-4.2,4.8S106.9,19.6,106.9,17z M102.4,17
c0,4.7,3.2,8.6,8.6,8.6s8.6-3.9,8.6-8.6c0-4.6-3.2-8.5-8.6-8.5C105.6,8.4,102.4,12.4,102.4,17z"
      />
      <path
        fill="#383838"
        d="M95.7,25.6c-5,0-8.6-3.5-8.6-8.6c0-5,3.6-8.5,8.6-8.5c2.5,0,4.9,0.9,5.6,2.2c0.1,0.2,0.2,0.5,0.2,0.8
c0,1.1-1.1,1.8-2,1.8c-0.4,0-0.8-0.1-1.2-0.3c-0.7-0.4-1.6-0.7-2.4-0.7c-2.6,0-4.4,1.9-4.4,4.7s1.8,4.8,4.4,4.8
c0.9,0,1.7-0.2,2.4-0.7c0.4-0.2,0.7-0.3,1.1-0.3c1,0,2.1,0.7,2.1,1.9c0,0.5-0.2,1-0.7,1.4C99.7,24.9,98,25.6,95.7,25.6z"
      />
      <path
        fill="#383838"
        d="M72.2,16.9c0-3.1,1.8-5.8,5-5.8s5,2.7,5,5.8s-1.8,5.8-5,5.8C74,22.8,72.2,20,72.2,16.9z M69.1,16.9
c0,4.6,3.1,8.5,8.1,8.5s8.1-3.8,8.1-8.5c0-4.6-3.1-8.4-8.1-8.4S69.1,12.3,69.1,16.9z"
      />
      <path
        fill="#383838"
        d="M64.2,23.7v-9.5c0-1.9-0.8-3.1-2.8-3.1c-1.6,0-3.3,1.2-4,2.3v10.3c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5
v-9.5c0-1.9-0.8-3.1-2.8-3.1c-1.6,0-3.2,1.2-4,2.4v10.2c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5V10.1c0-0.8,0.7-1.4,1.5-1.4
s1.4,0.7,1.4,1.4v1c0.7-1,2.8-2.7,5.2-2.7c2.5,0,3.9,1.3,4.4,3c0.9-1.5,3.1-3,5.4-3c3,0,4.6,1.6,4.6,4.9v10.4c0,0.8-0.7,1.5-1.5,1.5
S64.2,24.5,64.2,23.7z"
      />
      <path
        fill="#383838"
        d="M29.4,16.9c0-3.1,1.8-5.8,5-5.8s5,2.7,5,5.8s-1.8,5.8-5,5.8C31.3,22.8,29.4,20,29.4,16.9z M26.4,16.9
c0,4.6,3.1,8.5,8.1,8.5s8.1-3.8,8.1-8.5c0-4.6-3.1-8.4-8.1-8.4S26.4,12.3,26.4,16.9z"
      />
      <path
        fill="#383838"
        d="M20.9,13.8v9.9c0,0.8-0.7,1.5-1.5,1.5l0,0c-0.8,0-1.4-0.7-1.4-1.5V10.1c0-0.8,0.7-1.4,1.5-1.4
s1.4,0.7,1.4,1.4v1.3c0.9-1.2,2.4-2.7,4.2-2.7c0.8,0,1.3,0.6,1.3,1.3c0,0.9-0.7,1.5-1.5,1.6C23.3,11.7,21.8,12.4,20.9,13.8z"
      />
      <path
        fill="#383838"
        d="M3.9,13.5c-0.5,0-1-0.4-1-0.9V6.7c0-0.5,0.4-1,1-1h4.9c2.4,0,4.1,1.6,4.1,3.9s-1.7,3.9-4.1,3.9H3.9z M2,3
C0.8,3,0,3.8,0,5v18.5c0,0.9,0.6,1.6,1.5,1.6S3,24.4,3,23.5V16h5.7c4.5,0,7.1-2.8,7.1-6.5S13.3,3,8.7,3H2z"
      />
    </svg>
  )
}
export default Logo
